function formatToDecimal(number) {
    number += '';
    var x = number.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function roundNumber(num, scale) {
    if (Math.round(num) != num) {
        if (Math.pow(0.1, scale) > num) {
            return 0;
        }
        var sign = Math.sign(num);
        var arr = ("" + Math.abs(num)).split(".");
        if (arr.length > 1) {
            if (arr[1].length > scale) {
                var integ = +arr[0] * Math.pow(10, scale);
                var dec = integ + (+arr[1].slice(0, scale) + Math.pow(10, scale));
                var proc = +arr[1].slice(scale, scale + 1)
                if (proc >= 5) {
                    dec = dec + 1;
                }
                dec = sign * (dec - Math.pow(10, scale)) / Math.pow(10, scale);
                return dec;
            }
        }
    }
    return num;
}

export { formatToDecimal, roundNumber };


// WEBPACK FOOTER //
// ./src/utils/Number/NumberUtils.js